export const serverUrl = "https://alertcomm-express.azurewebsites.net";
// export const serverUrl = "http://localhost:3001";
